import { defineMessages } from "react-intl";

const RESET_SUCCESS_INDICATOR = "reset-success-indicator";

const resetSuccessindicatorMessages = defineMessages({
  passwordReset: {
    id: `${RESET_SUCCESS_INDICATOR}.password-reset`,
    defaultMessage: "Password reset"
  },
  signInToContinue: {
    id: `${RESET_SUCCESS_INDICATOR}.sign-in-to-continue`,
    defaultMessage:
      "Your password has been reset. Please sign in with your new password."
  }
});

export default resetSuccessindicatorMessages;
